import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import request from '../../lib/requester'
import _ from 'lodash'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import { Link } from 'react-router-dom';
import axios from 'axios'
import Autocomplete from '../../component/autocomplete'
import moment from 'moment'

class userUpdate extends Component {
    constructor(props) {        
        super(props);
        this.state = {
       
        loading: false,
        success: '',
        error: [],
        username: '',
        realname: '',
        // password: '',
        activeflag: '',
        lovprinc :[],
        listprinc: [],
        lovrole: [],
     
        roleid: '',
     
        princid:'',
        assignprinc:[],
        princList:[],
        updateBy: '',
        phone: ''

        }
        }

        componentDidMount = () => {
            // let user = JSON.parse(window.localStorage.getItem('is_user'))
            // let principalName = user.org_name
            // this.setState({ principalName: principalName })
            // this.getprinc()
            // this.getDocumentList()
            // this.getProgramMember()
            this.getDetailUser()
        }
    
        getDetailUser = () => {
            let url = '/api/infostep/v1/user/userupdate'
            let { id } = this.props.match.params
            let param = {
                user_id: id
            }
            this.setState({ loading: true })
            request.postInfostep(url, param, {
                success: function(response) {

                    console.log(response.data.data)
                    let { header, princlov, role, princ} = response.data.data
                    // console.log(response.data.data.princ)
                    // let header = response.data.data.header
                    // let docs = response.data.data.docs
                    // let attachment = response.data.data.attachment
                    // let product = response.data.data.product
                    // let princContainer = response.data.data.princ
                    // // let princContainer = princ.map((item, index) => {
                    // //     return item.princ_id
                    // // })
    
                    // // let princContainer = response.data.data.princ.princ_id
    
                    let user = JSON.parse(window.localStorage.getItem('is_user'))
                    let idcabang = user.org_id



    
                    console.log(user.org_id)
    
                    this.setState({ 
                        loading: false,
                        username: header.username,
                        realname: header.realname,
                        roleid: header.role_id,
                        // password: header.password,
                     
                        activeflag: header.active_flag,
                        lovprinc: princlov,
                        listprinc: princ,
                        lovrole: role,
                     
                        updateBy: user.user_id,
                        phone: header.phone,
                        princid: princ.org_id
                    })
                    // this.getProgramType()
                    // this.getBudgetType()
                    // this.getDocumentList()
                }.bind(this),
                error: function(err) {
                    console.log(err)
                    this.setState({ loading: false })
                }.bind(this)
            })
        }

    showError = () => {
        if (this.state.error.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    <ul>
                        { this.state.error.map((item, index) => {
                            return (<li key={index}>{item}</li>)
                        })}
                    </ul>
                </div>
            )
        }
    }

    showSuccess = () => {
        if (this.state.success.length > 0) {
            return (
                <div className="alert alert-success" role="alert">
                    { this.state.success }
                </div>
            )
        }
    }

    
    renderButton = () => {

            return (
                <div className="col-sm-9">
                    <button type = "button" className="btn btn-success" onClick={ this.handleSave.bind(this) }>Update</button>&nbsp;
                    <button type = "button" className="btn btn-warning" onClick={ this.handleCancel.bind(this) }>Cancel</button>
                </div>
            )
    }



    handleSave = () => {
            if (this.validateForm()) {
                let url = "/api/infostep/v1/user/update"
                // let { skbNumber, supplierId, supplier, supplierSite, potongTagihan, pphRate, pphType, dpp, pph, ppn, totalAmount, fileContainer } = this.state
                // let { id } = this.props.match.params
                let param = {
                    username: this.state.username, 
                    realname: this.state.realname, 
                    // password: this.state.password,
                    phone: this.state.phone , 
                    role_id: this.state.roleid, 
                    active_flag: this.state.activeflag, 
                    updated_by: this.state.updateBy, 
                    princ: this.state.princid
                }
    
                this.setState({ loading: true })
                request.postInfostep(url, param, {
                    success: function (response) {
                        this.setState({ loading: false, success: response.data.message })
                        window.scrollTo(0, 0)
                        let app = this
                        window.setTimeout(() => {
                            app.props.history.push('/admin/setup/user/userlist')
                        }, 2000)
                    }.bind(this),
                    error: function (e) {
                        window.scrollTo(0, 0)
                        this.setState({ loading: false, error: ['Failed to submit, please try again'] })
                    }.bind(this)
                })
            }
    }

    validateForm = () => {
        let count = 0
        let error = []
        this.setState({ error: [], success: '' })
        if (this.state.username.length === 0) {
            error.push('Username is empty')
            ++count
        } else if (this.state.realname.length === 0) {
            error.push('Realname is empty')
            ++count
        // } else if (this.state.password.length === 0) {
        //     error.push('Password is empty')
        //     ++count
        // } else if (this.state.phone.length === 0) {
        //     error.push('Phone is empty')
        //     ++count
        } else if (this.state.role_id === 0 ) {
            error.push('Role is empty')
            ++count
        } else if (this.state.active_flag === 0) {
            error.push('Active flag is empty')
            ++count
        }else if (this.state.princid === 0) {
            error.push('Principal is empty')
            ++count
        }

        if (count > 0) {
            this.setState({ error: error})
            window.scrollTo(0, 0)
            return false
        } else {
            return true
        }
    }
    handleCancel = () => {
        let app = this
        window.setTimeout(() => {
            app.props.history.push('/admin/setup/userlist')
        }, 2000)
    }

    handleChangePrinc = (event) => {
        let value = event.target.value
        let name = event.target.name

        this.setState({ princid: value})
        window.setTimeout(() => {
            console.log(this.state.princid)
        }, 100)
    }

    handleChangeRole = (event) => {
        let value = event.target.value
        let name = event.target.name

        this.setState({ roleid: value })
        window.setTimeout(() => {
            console.log(this.state.roleid)
        }, 100)
    }
    handleChangeActive = (event) => {
        let value = event.target.value
        let name = event.target.name

        this.setState({ activeflag: value })
        window.setTimeout(() => {
            console.log(this.state.activeflag)
        }, 100)
    }

    setChecked = (item) => {
        let find = _.find(this.state.listprinc, function(o) {
            return o.org_id === item.org_id
        })
        return (find) ? true : false
    }
    

    handleClickprinc = (e) => {
        let is_checked = e.target.checked
        let org = e.target.value
        // let  { princList } = this.state
        if (is_checked) {
            this.state.listprinc.push({ org_id : parseInt(org) })
        } 
        else {
            let getIndex = _.findIndex(this.state.listprinc, function(o) {
                return parseInt(o.org_id) === parseInt(org)
            })
            this.state.listprinc.splice(getIndex, 1)
        }
        // this.setState(princList)
        console.log(this.state.listprinc)
    }

    renderPrinc = () => {
        return this.state.lovprinc.map((item, index) => (
            <div className="col-md-4" key={index}>
                <div className="form-check">
                    <input className="form-check-input" defaultChecked={ this.setChecked(item) } type="checkbox" value={ item.org_id }  onChange={ this.handleClickprinc.bind(this) } id="defaultCheck1" />
                    <label className="form-check-label" htmlFor="defaultCheck1">
                        {item.org_name}
                    </label>
                </div>
            </div>
        ))
    }

    handleChangeUsername = (e) => {
            let is_value = e.target.value
            this.state.username = is_value
    }

    // handleChangePassword = (e) => {
    //     let is_value = e.target.value
    //     this.state.password = is_value
    // }

    handleChangeRealname = (e) => {
        let is_value = e.target.value
        this.state.realname = is_value
    }

    handleChangePhone = (e) => {
        let is_value = e.target.value
        this.state.phone = is_value
    }

   

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12 col-sx-12">
                                <div className="card card-info">
                                <div className="card-header">User Information</div>
                                    {/* <div className="card-header">Form</div> */}
                                    <div className="card-body">
                                        { this.showSuccess() }
                                        { this.showError() }
                                        <form className="form-horizontal">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Username</label>
                                                            <div className="col-sm-9">
                                                                <input disabled type="text" className="form-control" id="userName" name="userName" placeholder="" defaultValue={this.state.username} onChange={this.handleChangeUsername.bind(this)} />
                                                            </div>
                                                    </div>
                                                    {/* <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Password</label>
                                                            <div className="col-sm-9">
                                                                <input type="password" className="form-control" id="password" name="password" placeholder="password" defaultValue={this.state.password} onChange={this.handleChangePassword.bind(this)}/>
                                                            </div>
                                                    </div> */}
                                                    <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Realname</label>
                                                            <div className="col-sm-9">
                                                                <input type="text" className="form-control" id="realname" name="realName" placeholder="realname" defaultValue={this.state.realname} onChange={this.handleChangeRealname.bind(this)}/>
                                                            </div>
                                                    </div>
                                                    <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Phone</label>
                                                            <div className="col-sm-9">
                                                                <input type="text" className="form-control" id="phone" name="phone" placeholder="" defaultValue={this.state.phone} onChange={this.handleChangePhone.bind(this)} />
                                                            </div>
                                                    </div>
                                                 

                                                </div>

                                                <div className="col-md-6" >

                                                <div className="form-group row" >
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Principal</label>
                                                            <div className="col-sm-9">
                                                            <select className="form-control"  name="princ" value={ this.state.princid } onChange={ this.handleChangePrinc.bind(this)}>
                                                                        <option value ={0}>- Select Principal -</option>
                                                                        { this.state.lovprinc.map((item, index) => (
                                                                            <option value={item.org_id} key={index}>{item.org_name}</option>
                                                                        ))}
                                                                    </select>
                                                            </div>
                                                    </div>

                                                    <div className="form-group row" >
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Role</label>
                                                            <div className="col-sm-9">
                                                            <select className="form-control"  name="role" value={ this.state.roleid } onChange={ this.handleChangeRole.bind(this)}>
                                                                        <option value ={0}>- Select Role -</option>
                                                                        { this.state.lovrole.map((item, index) => (
                                                                            <option value={item.role_id} key={index}>{item.role_name}</option>
                                                                        ))}
                                                                    </select>
                                                            </div>
                                                    </div>
                                                  

                                                    <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Active</label>
                                                            <div className="col-sm-9">
                                                            <select className="form-control"  name="activeFlag" value={ this.state.activeflag } onChange={ this.handleChangeActive.bind(this)}>
                                                                        <option value="Y" > Y </option>
                                                                        <option value="N" > N </option>
                                                                    </select>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />
                                            {/* <div className="row">
                                                <div className="col-md-8">
                                                    <h5>Principal</h5>
                                                    <div className="row">
                                                        { this.renderPrinc() }
                                                    </div>
                                                </div>
                                            </div> */}
                                            <hr />
                                            <div className="form-group row">
                                                <div className="col-md-6">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label"></label>
                                                        { this.renderButton() }
                                            </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <Loader fullPage loading={this.state.loading} />
                </section>
            </div>
        )
    }
}

export default userUpdate
